export const getLanguageFromPath = (pathname = '/') =>
  pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'tr';

const stripEnglishPrefix = (pathname = '/') => {
  if (pathname === '/en' || pathname === '/en/') {
    return '/';
  }

  if (pathname.startsWith('/en/')) {
    return pathname.slice(3) || '/';
  }

  return pathname || '/';
};

export const getLocalizedPath = (pathname = '/', language = 'tr') => {
  const basePath = stripEnglishPrefix(pathname);

  if (language === 'en') {
    return basePath === '/' ? '/en' : `/en${basePath}`;
  }

  return basePath;
};
